import type { FC } from 'react';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Box, Stack, TableCell, TableRow } from '@mui/material';
import { format } from 'date-fns';
import { Trans } from 'react-i18next';

import { MenuButton, ResolutionLevelBlock } from '../../../components/base';
import { getAiIncidentUserName } from '../lib/getAiIncidentUserName';
import type { AiIncident } from '../model/types';

type AiIncidentsTableRowProps = {
  aiIncident: AiIncident;
  isDeleteLoading?: boolean;
  onConfirm?: (aiIncident: AiIncident) => void;
  onDelete?: (aiIncident: AiIncident) => void;
};

const formatDate = (date?: Date) => {
  if (!date) {
    return '';
  }

  return format(date, 'HH:mm, dd.MM.yyyy');
};

export const AiIncidentsTableRow: FC<AiIncidentsTableRowProps> = ({
  aiIncident,
  isDeleteLoading,
  onConfirm,
  onDelete,
}) => (
  <TableRow
    hover
    key={aiIncident.id}
    sx={{ cursor: 'pointer' }}
    onClick={() => onConfirm?.(aiIncident)}
  >
    <TableCell>
      <Stack direction='row' spacing={1} alignItems='center'>
        <span>{aiIncident.id}</span>
        {!aiIncident.isViewed && (
          <Box
            sx={{
              marginLeft: '2px',
              width: '6px',
              height: '6px',
              background: '#F2A861',
              borderRadius: '50%',
            }}
          />
        )}
      </Stack>
    </TableCell>
    <TableCell component='th' scope='row'>
      {aiIncident.title}
    </TableCell>
    <TableCell>{aiIncident.description}</TableCell>
    <TableCell>{aiIncident.location?.title}</TableCell>
    <TableCell>{getAiIncidentUserName(aiIncident.responsible)}</TableCell>
    <TableCell>{getAiIncidentUserName(aiIncident.control)}</TableCell>
    <TableCell>{aiIncident.userFunction?.name}</TableCell>
    <TableCell>{aiIncident.resolutionLevel && <ResolutionLevelBlock level={aiIncident.resolutionLevel} />}</TableCell>
    <TableCell>{getAiIncidentUserName(aiIncident.registerBy)}</TableCell>
    <TableCell>{formatDate(aiIncident.createdAt)}</TableCell>
    <TableCell>{aiIncident.source}</TableCell>
    <TableCell>{aiIncident.certainty}%</TableCell>
    <TableCell onClick={(event) => event.stopPropagation()}>
      <MenuButton
        isLoading={isDeleteLoading}
        sx={{ border: 0 }}
        buttonContent={<MoreHorizIcon />}
        commands={[
          { content: <Trans i18nKey='confirm' />, onClick: () => onConfirm?.(aiIncident) },
          { content: <Trans i18nKey='delete' />, onClick: () => onDelete?.(aiIncident) },
        ]}
      />
    </TableCell>
  </TableRow>
);
